import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScreenNormal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.25 3C8.66421 3 9 3.33579 9 3.75V7.25C9 8.2165 8.2165 9 7.25 9H3.75C3.33579 9 3 8.66421 3 8.25C3 7.83579 3.33579 7.5 3.75 7.5H7.25C7.38807 7.5 7.5 7.38807 7.5 7.25V3.75C7.5 3.33579 7.83579 3 8.25 3ZM15.75 3C16.1642 3 16.5 3.33579 16.5 3.75V7.25C16.5 7.38807 16.6119 7.5 16.75 7.5H20.25C20.6642 7.5 21 7.83579 21 8.25C21 8.66421 20.6642 9 20.25 9H16.75C15.7835 9 15 8.2165 15 7.25V3.75C15 3.33579 15.3358 3 15.75 3ZM3 15.75C3 15.3358 3.33579 15 3.75 15H7.25C8.2165 15 9 15.7835 9 16.75V20.25C9 20.6642 8.66421 21 8.25 21C7.83579 21 7.5 20.6642 7.5 20.25V16.75C7.5 16.6119 7.38807 16.5 7.25 16.5H3.75C3.33579 16.5 3 16.1642 3 15.75ZM15 16.75C15 15.7835 15.7835 15 16.75 15H20.25C20.6642 15 21 15.3358 21 15.75C21 16.1642 20.6642 16.5 20.25 16.5H16.75C16.6119 16.5 16.5 16.6119 16.5 16.75V20.25C16.5 20.6642 16.1642 21 15.75 21C15.3358 21 15 20.6642 15 20.25V16.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgScreenNormal;
